/**
 * Fixed banner for a LOCAL portal (`vite dev`) so it is always obvious which
 * backend is behind the screen. Never renders on the deployed site — and the
 * whole body sits inside `if (import.meta.env.DEV)`, which a build turns into
 * `if (false)`, so the bundler deletes it from the production bundle.
 *  - green: REHEARSAL — local emulators, fake money, nothing real is touched
 *  - red:   LOCAL → LIVE — this laptop is talking to the real system
 */

import { IS_LOCAL_LIVE, IS_REHEARSAL, REHEARSAL_PROJECT_ID } from '../../services/firebase';

export function RehearsalBanner() {
  if (import.meta.env.DEV) {
    if (!IS_REHEARSAL && !IS_LOCAL_LIVE) return null;
    const live = IS_LOCAL_LIVE;
    return (
      <div style={{
        position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 5000,
        padding: '6px 12px', textAlign: 'center', fontSize: '0.8rem', fontWeight: 700, letterSpacing: '0.5px',
        color: live ? '#fff' : '#062b1c', background: live ? '#b91c1c' : '#34d399',
        pointerEvents: 'none',
      }}>
        {live
          ? 'LOCAL PORTAL → LIVE SYSTEM — real clients, real Stripe, real email'
          : `REHEARSAL — fake money — local emulators only (${REHEARSAL_PROJECT_ID}). Calls, emails and lead uploads are switched off here.`}
      </div>
    );
  }
  return null;
}
